import React, { ReactNode } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import OptionIcon from "@material-ui/icons/MoreVert";

interface IListItemProps {
  title: string;
  titleIndicator?: ReactNode;
  subtitle?: string;
  link?: string;
  options?: Array<{
    label: ReactNode;
    payload?: any;
    action: (payload?: any) => void;
  }>;
}

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
  },
}));

export const ListItem = ({
  title,
  titleIndicator,
  subtitle,
  options,
}: IListItemProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box padding={1} display="flex" alignItems="center">
      <Box flexGrow={1}>
        <Typography variant="h6" className={classes.title}>
          {title}
          <Box ml={1} component="span" display="flex" alignItems="center">
            {titleIndicator}
          </Box>
        </Typography>
        <Typography variant="body2" color="textSecondary">
          <Box component="span" fontStyle="italic">
            {subtitle}
          </Box>
        </Typography>
      </Box>
      {options && (
        <Box>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <OptionIcon />
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {options.map((option, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  option.action(option.payload);
                  handleClose();
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      )}
    </Box>
  );
};
